module.exports = __webpack_public_path__ + "img/linkedinsvg.2ed03b21.svg";